import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Person\SearchPersonController::__invoke
* @see app/Http/Controllers/Person/SearchPersonController.php
* @route '/api/search-person'
*/
const SearchPersonController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchPersonController.url(options),
    method: 'get',
})

SearchPersonController.definition = {
    methods: ["get","head"],
    url: '/api/search-person',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Person\SearchPersonController::__invoke
* @see app/Http/Controllers/Person/SearchPersonController.php
* @route '/api/search-person'
*/
SearchPersonController.url = (options?: RouteQueryOptions) => {
    return SearchPersonController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Person\SearchPersonController::__invoke
* @see app/Http/Controllers/Person/SearchPersonController.php
* @route '/api/search-person'
*/
SearchPersonController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchPersonController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Person\SearchPersonController::__invoke
* @see app/Http/Controllers/Person/SearchPersonController.php
* @route '/api/search-person'
*/
SearchPersonController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SearchPersonController.url(options),
    method: 'head',
})

export default SearchPersonController